import api, { handleResponse, handleError } from './api';

const userService = {
  /**
   * Get the current authenticated user
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async getCurrentUser() {
    try {
      const response = await api.get('/users/me');
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Update the current user's information
   * @param {object} data - User data to update
   * @param {string} [data.email] - New email
   * @param {string} [data.phoneNumber] - New phone number
   * @param {string} [data.password] - New password
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async updateUser(data) {
    try {
      const response = await api.put('/users/me', data);
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Set the user's mode (host or guest)
   * @param {string} mode - The mode to set ('host' or 'guest')
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async setMode(mode) {
    try {
      const response = await api.put('/users/me/mode', { mode });
      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Delete the current user's account
   * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
   */
  async deleteAccount() {
    try {
      const response = await api.delete('/users/me');

      // Clear auth tokens after account deletion
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');

      return handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default userService;
